export default "__VITE_ASSET__DzCe13jr__"